import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import { toast } from '@/hooks/use-toast';
import { useUserStore } from '@/hooks/useUserStore';
import { LocalStorage } from '@/utils/LocalStorage';
import { useLogoutQuery } from '@viome/viome-base/src/usecase/Login/LoginQuery';
import { LoadingPage } from '../LoadingPage';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH, LOGIN_PATH } from '@/constants/paths';
import { useQueryClient } from '@tanstack/react-query';

export const RegistrationPendingKit = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const primaryActionOnClick = () => navigate(HOME_PATH);
  const { setUser } = useUserStore();
  const { refetch: logout, isLoading } = useLogoutQuery({ enabled: false });

  if (isLoading) {
    return <LoadingPage />;
  }

  const handleLogout = async () => {
    try {
      await logout();
      setUser(undefined);
      LocalStorage.clear();
      LocalStorage.removeItem('user');
      LocalStorage.removeItem('bootup');
      queryClient.clear();
      navigate(LOGIN_PATH);
    } catch (error) {
      toast({
        variant: 'destructive',
        description: 'Failed to logout, please try again',
      });
    }
  };

  return (
    <RegistrationScreen
      title="Oops! Only one kit at a time"
      description="Before registering a new kit, you will have to review results and
        recommendations for your most recent active kit."
      primaryActionLabel="Review results"
      primaryActionOnClick={primaryActionOnClick}
      secondaryActionLabel="Login as a different user"
      secondaryActionOnClick={handleLogout}
    />
  );
};
